import { API_SEND_OTP_REGISTER } from "services/endpoints";

export default (build) =>
	build.mutation({
		query: ({ newEmail: email }) => {
			return {
				url: API_SEND_OTP_REGISTER,
				method: "POST",
				data: {
					email
				}
			};
		},
		invalidatesTags: []
	});
